import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetDriverMapPingsQueryVariables = Types.Exact<{
  driverId: Types.Scalars['bigint']['input'];
  todayStart: Types.Scalars['timestamptz']['input'];
}>;


export type GetDriverMapPingsQuery = { __typename?: 'query_root', driverlocations: Array<{ __typename?: 'driverlocations', id: string, location: object, time: string, move_id?: number | null, speed?: number | null, heading?: number | null, accuracy?: number | null, battery_level?: number | null, battery_is_charging: boolean, is_moving: boolean, activity_type?: string | null }> };


export const GetDriverMapPingsDocument = gql`
    query getDriverMapPings($driverId: bigint!, $todayStart: timestamptz!) {
  driverlocations(
    where: {driver_id: {_eq: $driverId}, time: {_gte: $todayStart}}
    order_by: {time: asc}
    limit: 5000
  ) {
    id
    location
    time
    move_id
    speed
    heading
    accuracy
    battery_level
    battery_is_charging
    is_moving
    activity_type
  }
}
    `;

/**
 * __useGetDriverMapPingsQuery__
 *
 * To run a query within a React component, call `useGetDriverMapPingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverMapPingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverMapPingsQuery({
 *   variables: {
 *      driverId: // value for 'driverId'
 *      todayStart: // value for 'todayStart'
 *   },
 * });
 */
export function useGetDriverMapPingsQuery(baseOptions: Apollo.QueryHookOptions<GetDriverMapPingsQuery, GetDriverMapPingsQueryVariables> & ({ variables: GetDriverMapPingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverMapPingsQuery, GetDriverMapPingsQueryVariables>(GetDriverMapPingsDocument, options);
      }
export function useGetDriverMapPingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverMapPingsQuery, GetDriverMapPingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverMapPingsQuery, GetDriverMapPingsQueryVariables>(GetDriverMapPingsDocument, options);
        }
// @ts-ignore
export function useGetDriverMapPingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDriverMapPingsQuery, GetDriverMapPingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDriverMapPingsQuery, GetDriverMapPingsQueryVariables>;
export function useGetDriverMapPingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDriverMapPingsQuery, GetDriverMapPingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDriverMapPingsQuery | undefined, GetDriverMapPingsQueryVariables>;
export function useGetDriverMapPingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDriverMapPingsQuery, GetDriverMapPingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDriverMapPingsQuery, GetDriverMapPingsQueryVariables>(GetDriverMapPingsDocument, options);
        }
export type GetDriverMapPingsQueryHookResult = ReturnType<typeof useGetDriverMapPingsQuery>;
export type GetDriverMapPingsLazyQueryHookResult = ReturnType<typeof useGetDriverMapPingsLazyQuery>;
export type GetDriverMapPingsSuspenseQueryHookResult = ReturnType<typeof useGetDriverMapPingsSuspenseQuery>;
export type GetDriverMapPingsQueryResult = Apollo.QueryResult<GetDriverMapPingsQuery, GetDriverMapPingsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/moves/queries/getDriverMapPings.query.gql}
 */
export async function getDriverMapPings(
  variables: GetDriverMapPingsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetDriverMapPingsQuery['driverlocations']>
export async function getDriverMapPings(
  variables: GetDriverMapPingsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetDriverMapPingsQuery>
export async function getDriverMapPings(
  variables: GetDriverMapPingsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetDriverMapPingsQuery['driverlocations'] | GetDriverMapPingsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetDriverMapPingsQuery>(
    GetDriverMapPingsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.driverlocations
}